import { render, staticRenderFns } from "./governmentBigData.vue?vue&type=template&id=18567588&scoped=true&"
import script from "./governmentBigData.vue?vue&type=script&lang=js&"
export * from "./governmentBigData.vue?vue&type=script&lang=js&"
import style0 from "./governmentBigData.vue?vue&type=style&index=0&id=18567588&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18567588",
  null
  
)

export default component.exports